import React, { useState, useEffect } from 'react';

import { withNavbar } from '../Navbar';
import { withRouterProps } from '../../../common/withRouterProps';

import { makeStyles } from "@mui/styles";

import Typography from '@mui/material/Typography';

import { Grid, Tab, Tabs } from '@mui/material';
import { horizontalTabStyles, verticalTabStyles } from '../sharedStyles';

import { v2UIRoutePath } from '../../../common/commons';

import RequestQueue from './RequestQueue';

import DailyFeed from './DailyFeed';

import CPSHealthCheck from './CPSHealthCheck';

import BulkUpload from './BulkUpload';

import RoutingValidator from './RoutingValidator';

const useStyles = makeStyles(() => ({
    homePageWrapper: {
        fontSize: '0.8rem',
        height: "100%",
        // margin: "15px"
    },
    adminTabWrapper: {
        background: '#fff',
        height: "calc( 100% - 40px)"
    },
    headerTitle: {
        textAlign: "center",
        flexGrow: 1,
        fontWeight: "bold",
        marginTop: '20px',
        marginBottom: '14px'
    },
    verticalTabGridItem: {
        maxWidth: '170px',
        background: '#f5f7fa',
        borderRight: '1px solid #e2e8f0',
        borderRadius: '10px 0 0 10px',
        padding: '10px 0',
    },
    verticalTabGridContent: {
        maxWidth: 'calc( 100% - 160px)',
        background: '#fff',
        // padding: '10px',
    },
    ...verticalTabStyles,
    appsScopeWrapper: {
        ...horizontalTabStyles.tabWrapper,
        '& .scopeHeader': {
            padding: '10px 20px',
            fontSize: '1rem',
            fontWeight: 'bold',
            '& a': {
                color: "#212529"
            }
        },
    }
}));
// TabHistoryPaths Variable Holds all the tab paths available in the Tracking Screen
const TabHistoryPaths = [
    "bulkupload",
    "cpshealthcheck",
    "dailyfeed",
    "requestqueue",
    "routingvalidator"
];

function Tracking(props) {
    const classes = useStyles();
    const [verticalTab, setVerticalTab] = useState(0);
    const { routerProps } = props
    const { history, match } = routerProps;
    useEffect(() => {
        if (match?.params?.page) {
            setVerticalTab(TabHistoryPaths.indexOf(match?.params?.page));
        }
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[match])
    const activeTabName = TabHistoryPaths[verticalTab];
    return (
        <div className={`${classes.homePageWrapper}`}>
            <Typography variant="h6" className={classes.headerTitle}>
                Requests Tracking
            </Typography>
            <Grid container className={classes.adminTabWrapper}>
                <Grid item xs className={classes.verticalTabGridItem}>
                    <div className={classes.verticalTabWrapper}>
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={verticalTab}
                            onChange={(_event, newValue) => {
                                setVerticalTab(newValue);
                                const path = TabHistoryPaths[newValue];
                                history.push(`${v2UIRoutePath}tracking/${path}`)
                            }}
                            aria-label="Vertical tabs"
                        >
                            <Tab label="Bulk Upload" />
                            <Tab label="CPS Health Check" />
                            <Tab label="Daily Feed" />
                            <Tab label="Request Queue" />
                            <Tab label="Routing Validator" />
                        </Tabs>
                    </div>

                </Grid>
                <Grid item xs className={classes.verticalTabGridContent}>
                    <div className={classes.appsScopeWrapper}>
                        {activeTabName === "requestqueue" && (
                            <RequestQueue routerProps={routerProps} />
                        )}
                        {activeTabName === "dailyfeed" && (
                            <DailyFeed />
                        )}
                        {activeTabName === "bulkupload" && (
                            <BulkUpload />
                        )}
                        {activeTabName === "cpshealthcheck" && (
                            <CPSHealthCheck />
                        )}
                        {activeTabName === "routingvalidator" && (
                            <RoutingValidator />
                        )}
                        

                    </div>
                </Grid>
            </Grid>
        </div>
    );
}

export default withNavbar(withRouterProps(React.memo(Tracking)), 1);
